/**
 * Parallax Reveal - GSAP ScrollTrigger
 * Section 2 content starts below viewport (-50vh), then rises as you scroll.
 * When section 1's bottom touches the top of the window, section 2 has just
 * reached y: 0 so you see it come from the bottom and land.
 */
(function () {
  function initParallaxReveal() {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined")
      return;

    gsap.registerPlugin(ScrollTrigger);
    const isMobile = window.matchMedia("(max-width: 999px)").matches;

    document
      .querySelectorAll(".parallax-reveal[data-section-id]")
      .forEach(function (section) {
        const contentSection = section.querySelector(
          ".parallax-reveal__content"
        );
        const stickySection = section.querySelector(".parallax-reveal__sticky");
        const content = section.querySelector("[data-parallax-content]");
        const reveal = section.querySelector("[data-parallax-reveal]");
        if (!contentSection || !stickySection || !content) return;

        ScrollTrigger.getAll().forEach(function (st) {
          if (
            st.trigger === contentSection ||
            (st.vars && st.vars.trigger === contentSection)
          )
            st.kill();
        });

        gsap.set(content, { y: "-50vh" });

        gsap.to(content, {
          y: 0,
          ease: "none",
          force3D: true,
          scrollTrigger: {
            trigger: contentSection,
            start: "bottom bottom",
            end: isMobile ? "bottom 30%" :"bottom 20%",
            scrub: true,
            invalidateOnRefresh: true,
          },
        });
      });
  }

  function tryInit() {
    if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
      initParallaxReveal();
      return;
    }
    setTimeout(tryInit, 50);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", tryInit);
  } else {
    tryInit();
  }

  document.addEventListener("shopify:section:load", tryInit);
})();
